import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { CheckCircle } from "lucide-react";

interface Props {
  open: boolean;
  setOpen: (v: boolean) => void;
  closureContext: string;
  setClosureContext: (s: string) => void;
  onConfirm: () => Promise<void>;
  t: (k: string) => string;
  disabled?: boolean;
}

const ResolveDialog: React.FC<Props> = ({
  open,
  setOpen,
  closureContext,
  setClosureContext,
  onConfirm,
  t,
  disabled = false,
}) => (
  <Dialog open={open} onOpenChange={setOpen}>
    <DialogContent className="bg-white max-w-md w-full rounded-lg shadow-lg">
      <DialogHeader>
        <DialogTitle className="flex gap-2 items-center">
          <CheckCircle className="w-4 h-4 text-[#0064E0]" />
          <span className="text-lg text-[#13161A] font-normal">{t("resolve_issue")}</span>
        </DialogTitle>
      </DialogHeader>

      <textarea
        className="w-full border border-[#E2E4E9] rounded-lg p-2 resize-none h-44 bg-white text-sm font-normal placeholder:text-[#6F7D95] focus:outline-none focus:ring-1 focus:ring-[#0064E0]"
        placeholder={t("additional_information_optional")}
        value={closureContext}
        onChange={(e) => setClosureContext(e.target.value)}
      />

      <DialogFooter className="flex justify-end gap-2">
        <DialogClose asChild>
          <Button variant="secondary" className="bg-white border rounded-lg px-4 py-2">
            {t("cancel")}
          </Button>
        </DialogClose>
        <Button
          onClick={onConfirm}
          className="bg-[#105BDB] text-white hover:bg-[#679BF4] active:bg-[#0B2568] px-4 py-2 text-base font-normal rounded-lg"
          disabled={disabled}
        >
          {t("confirm")}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ResolveDialog;
